import { createContext } from "react";
import type { CoachesActionsContextType } from "./CoachesActionsContext.types";

const CoachesActionsContext = createContext<CoachesActionsContextType | undefined>(undefined);
CoachesActionsContext.displayName = "CoachesActionsContext";

export default CoachesActionsContext;
